import logo from './logo2.svg';
import './App.css';
import appVideo from "./jist.mp4";

function App() {
  return (
    <div className="App">
      <header className="hero">
        {/* LEFT TEXT */}
        <div className="hero-text">
          <img src={logo} alt="Jist App Logo" width="200" height="auto"/>
          <h1>
            Coming February 2026
          </h1>

          <p>
            Jist! makes it easy to discover healthier, more affordable alternatives to your cravings, creating personalized recipes you can save and share. 
          </p>
        </div>

        {/* RIGHT PHONE (VIDEO) */}
        <div className="phone-wrapper">
          <video
            className="phone-video"
            src={appVideo}
            autoPlay
            muted
            loop
            playsInline
          />
        </div>
      </header>
    </div>
  );
}

export default App;
